export default __webpack_public_path__ + "static/qr-code-PROD-f896e6f86d70cb67ba534a6f576670e6.png";